import { render, staticRenderFns } from "./InvoiceManage.vue?vue&type=template&id=b008fda6&scoped=true"
import script from "./InvoiceManage.vue?vue&type=script&lang=ts"
export * from "./InvoiceManage.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceManage.vue?vue&type=style&index=0&id=b008fda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b008fda6",
  null
  
)

export default component.exports